import React from 'react';
import { Alert, LinearProgress, Snackbar, Stack } from '@mui/material';
import { BulkResultDetails } from 'organisms/CloudOpsReportAdmin/bulk/BulkResultDetails';
import { BulkProgressState } from 'organisms/CloudOpsReportAdmin/bulk/types';

export const BulkProgressSnackbar = ({
  progress,
  onDismiss,
}: {
  progress: BulkProgressState | null;
  onDismiss: () => void;
}) => {
  if (!progress) return null;

  let percentage: number | undefined;
  if (progress.total !== undefined && progress.processed !== undefined) {
    percentage =
      progress.total === 0
        ? 0
        : Math.round((progress.processed / progress.total) * 100);
  }
  const showIndeterminateApproval =
    !progress.terminal &&
    progress.phase === 'approving' &&
    percentage === undefined;
  const autoHideDuration =
    progress.terminal && !progress.persistUntilDismissed ? 5000 : null;

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={autoHideDuration}
      onClose={(event, reason) => {
        if (progress.terminal && reason !== 'clickaway') onDismiss();
      }}
    >
      <Alert
        severity={progress.severity}
        variant="filled"
        onClose={progress.persistUntilDismissed ? onDismiss : undefined}
        closeText="Dismiss bulk result"
      >
        <Stack gap={1} minWidth={320}>
          <span>{progress.message}</span>
          {progress.details && progress.details.length > 0 && (
            <BulkResultDetails details={progress.details} />
          )}
          {(percentage !== undefined || showIndeterminateApproval) && (
            <LinearProgress
              variant={
                percentage === undefined ? 'indeterminate' : 'determinate'
              }
              value={percentage}
              aria-label="Bulk report progress"
            />
          )}
        </Stack>
      </Alert>
    </Snackbar>
  );
};
